package com.patronat.top.client.presentation.home.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import com.patronat.top.ui.theme.BodyLarge
import com.patronat.top.ui.theme.BodyMedium
import com.patronat.top.ui.theme.MineShaft50
import com.patronat.top.ui.theme.MineShaft500
import com.patronat.top.ui.theme.MineShaft950
import org.jetbrains.compose.resources.stringResource
import top.clientapp.generated.resources.Res
import top.clientapp.generated.resources.client_home_empty_description
import top.clientapp.generated.resources.client_home_empty_title

@Composable
fun HomeVenueEmptyState(
    modifier: Modifier = Modifier
) {
    Column(
        modifier = modifier
            .background(MineShaft50, RoundedCornerShape(12.dp))
            .padding(horizontal = 24.dp, vertical = 28.dp),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.spacedBy(8.dp)
    ) {
        Text(
            text = stringResource(Res.string.client_home_empty_title),
            style = BodyLarge.copy(
                color = MineShaft950,
                textAlign = TextAlign.Center
            )
        )

        Text(
            text = stringResource(Res.string.client_home_empty_description),
            style = BodyMedium.copy(
                color = MineShaft500,
                textAlign = TextAlign.Center
            )
        )
    }
}
